/*
 * @Author: Chris 
 * @Date: 2022-07-27 16:06:34 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-11-09 15:01:23
 */
<template>
  <div class="LoginPhone" @keydown.stop="()=>{}">
    <div v-if="login_pone == 1">
      <div class="input">
        <div class="input_name">手机号</div>
        <el-input
          v-model="phonenumber"
          placeholder="必填"
          @input="phonenumberinputChange"
        ></el-input>
      </div>
      <div class="input">
        <div class="input_name">验证码</div>
        <el-input v-model="pohoneCode" ref="code" placeholder="请输入验证码" class="name_getcode">
          <template slot="append">
            <div class="input_name_in" v-if="!count" @click="getCode">
              获取验证码
            </div>
            <div class="input_name_in" v-if="count">{{ count }}秒后重发</div>
          </template>
        </el-input>
      </div>
      <div class="login_button">
        <div class="button" @click="nextType">下一步</div>
      </div>
    </div>
    <div v-if="login_pone == 2">
      <div class="choose_title">
        选择组织
        <div class="choose_title_line"></div>
      </div>
      <div class="choose_list">
        <div
          class="choose_list_in"
          :class="choosecomID == item.companyId ? 'choose_list_inin' : ''"
          v-for="item in conList"
          :key="item.companyId"
          @click="choosecompany(item)"
        >
          <img
            v-if="!item.companyLogo"
            src="../../../assets/IMG/organization/compny.png"
            class="img_first"
            alt=""
          />
          <el-image
            class="left_img"
            v-if="item.companyLogo"
            :src="item.companyLogo"
            alt=""
          />
          {{ item.companyName }}
        </div>
      </div>
      <div class="login_button">
        <div class="button_left" @click="gobackM">上一步</div>
        <!-- <div class="button" @click="loginM">登录</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  phoneverifyCode,
  authverificationcodelogin,
  authdeptcompanyByPhone,
  loginByCode,
  basiccheckPhone,
} from "../../../api/api";
import { checkPhone } from '@/utils/tools';
export default {
  name: "LoginPhone",
  data() {
    return {
      login_pone: 1, //手机登录第一阶段
      input: "",
      phonenumber: "", //手机号
      pohoneCode: "", //验证码
      Timer: null, //验证码计时器
      count: null,
      conList: [], //公司列表
      choosecomID: null, //选择的公司
    };
  },

  methods: {
    /**
     * 点击选择公司
     * */

    choosecompany(e) {
      this.choosecomID = e.companyId;
      this.loginM();
    },

    /**
     * 返回上一步
     * */

    gobackM() {
      this.login_pone = 1;
      this.$store.commit("SET_LoginstatusbyPhone", 1);
      this.choosecomID = null;
    },

    /**
     * 下一步
     * */

    nextType() {
      let params = {
        phone: this.phonenumber,
        code: this.pohoneCode,
      };
      let this_ = this;
      basiccheckPhone(params).then((res) => {
        if (res.code == 200 && res.data) {
          this.$store.commit("SET_LoginstatusbyPhone", 2);
          let params = {
            phone: this.phonenumber,
            type: "user_management",
          };
          authdeptcompanyByPhone(params).then((res_) => {
            if (res_.code == 6005) {
              this.$notify.error({
                title: "错误",
                message: "非管理员角色不能登录",
              });
            } else {
              this.login_pone = 2;
              this.conList = res_.data;
              if (this.conList.length == 1) {
                this_.choosecomID = res_.data[0].companyId;
                this_.loginM();
              }
            }
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: res.msg,
          });
        }
      });
    },

    /**
     * 登录
     * */

    loginM() {
      if (this.phonenumber && this.pohoneCode && this.choosecomID) {
        let params = {
          phone: this.phonenumber,
          verifyCode: this.pohoneCode,
          companyId: this.choosecomID,
          sysCode: "user_management",
        };
        authverificationcodelogin(params).then((res) => {
          if (res.code == 200) {
            let par = {
              code: res.data,
            };
            loginByCode(par).then((res) => {
              if (res.code == 200) {
                window.localStorage.setItem("UM_accessToken", res.data);
                this.$notify.success({
                  title: "成功",
                  message: "登录成功，即将跳转到首页",
                });
                // this.$SET_All_Platform_Token(res.data);
                setTimeout(() => {
                  this.$router.push("/organization");
                }, 1000);
              }
            });
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "您输入的账号不存在或密码错误",
        });
      }
    },

    /**
     * 电话号码输入只能输入数字
     * */

    phonenumberinputChange(val) {
      this.phonenumber = this.phonenumber.replace(/[^0-9.]/g, "");
    },

    /**
     * 点击获取验证码
     * */

    getCode() {
      if (checkPhone(this.phonenumber)) {
        let params = {
          phone: this.phonenumber,
          type: "Login",
        };
        phoneverifyCode(params).then((res) => {
          if (res.code == 200) {
            this.countdown();
            this.$refs.code.focus();
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "手机号输入有误，请重新输入！",
        });
      }
    },

    /**
     * 60秒倒计时，验证码请求成功后开始
     * */

    countdown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.LoginPhone :deep(.el-input-group__append, .el-input-group__prepend) {
  background-color: #fff !important;
  color: #b7282d;
}

.LoginPhone
  :deep(.el-input-group__append:focus, .el-input-group__prepend:focus) {
  user-select: none !important;
  cursor: pointer !important;
}

.choose_title {
  width: 100%;
  text-align: center;
  color: #b7282d;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .choose_title_line {
    width: 20%;
    height: 0.0625rem;
    border-bottom: 0.125rem solid #b7282d;
  }
}

.choose_list {
  margin-top: 20px;
  height: 164px;
  overflow-y: auto;

  .choose_list_in {
    box-sizing: border-box;
    border: 0.0625rem solid #ededed;
    user-select: none;
    cursor: pointer;
    width: 98%;
    height: 3rem;
    background: #ededed;
    border-radius: 0.25rem;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    .right-icon {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 4px 0 4px;
      font-size: 12px;
      padding: 0 6px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #b7282d;
      background: rgba(183, 40, 45, 0.09);
    }
    .left_img {
      margin: 0 0.5rem;
      width: 2rem;
      height: 2rem;
    }
    .img_first {
      margin: 0 0.5rem;
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 1.125rem;
      border-radius: 0.25rem;
    }
  }
  :hover {
    box-sizing: border-box;
    border: 0.0625rem solid #b7282d;
  }

  .choose_list_inin {
    background: rgba(183, 40, 45, 0.06);
  }
}

.LoginPhone {
  width: 100%;
  .input {
    position: relative;
    padding: 1.25rem 0 0.625rem 0;
    .input_name {
      z-index: 5;
      position: absolute;
      color: #999999;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.375rem;
      background: #fff;
      left: 5%;
      top: 0.375rem;
    }

    .input_name_in {
      width: 100%;
      height: 100%;
      user-select: none;
      cursor: pointer;
    }
  }

  .erro {
    user-select: none;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.0625rem;
    color: #f84638;
  }

  .login_button {
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3.75rem;

    .button {
      cursor: pointer;
      width: 4rem;
      height: 2rem;
      background: #b7282d;
      border-radius: 0.25rem;
      color: #ffffff;
      font-size: 0.75rem;
      line-height: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .button_left {
      cursor: pointer;
      width: 4rem;
      height: 2rem;
      background: #fff;
      border-radius: 0.25rem;
      color: #b7282d;
      border: 0.0625rem solid #b7282d;
      box-sizing: border-box;
      margin-right: 0.625rem;
      font-size: 0.75rem;
      line-height: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>